/**
 * Opcoes do dropdown de reenvio no painel.
 *
 * As regras aqui espelham o `permite` da API de proposito, mas so para
 * desabilitar a opcao e explicar o porque antes do clique. **O portao de
 * verdade e o do servidor**: esta tela pode estar com dado velho (o pagamento
 * caiu enquanto o modal estava aberto), o servidor nao.
 */
// Rotulos curtos de proposito: o <select> nativo se dimensiona pela opcao mais
// longa, e textos grandes empurram o controle para fora do modal no celular.
export const TIPOS_REENVIO = [
  { valor: 'auto', rotulo: 'Automático' },
  { valor: 'confirmacao', rotulo: 'Confirmação com QR' },
  { valor: 'entrada', rotulo: 'Entrada paga' },
  { valor: 'cobranca', rotulo: 'Cobrança' }
]

export function motivoIndisponivel(tipo, inscricao) {
  const status = inscricao?.statusPagamento
  const quitada = status === 'QUITADA'
  // A tela nem sempre traz os pagamentos; na duvida, deixa habilitado e o
  // servidor decide. Bloquear por falta de dado esconderia opcao valida.
  const pagamentos = inscricao?.pagamentos
  const recebidos = Array.isArray(pagamentos)
    ? pagamentos.filter(p => p.status === 'RECEIVED').length
    : null

  if (tipo === 'auto') return null

  if (tipo === 'confirmacao') {
    return quitada ? null : 'Só para inscrição quitada — antes disso o QR Code não existe.'
  }

  if (tipo === 'entrada') {
    if (quitada) return 'Essa inscrição já está quitada. Use a confirmação com QR Code.'
    if (recebidos === 0) return 'Nenhum pagamento recebido ainda.'
    return null
  }

  if (tipo === 'cobranca') {
    return quitada ? 'Essa inscrição já está quitada.' : null
  }

  return null
}
